module.exports = __webpack_public_path__ + "information_16px.png?73b62476d4822ca6a47aadac1b78ec69";